import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BOTTOM_NAV } from '../../config/navigation';
import XiBotAvatar from './XiBotAvatar';

function isActive(pathname, to) {
  if (to === '/') return pathname === '/' || pathname === '';
  return pathname === to || pathname.startsWith(`${to}/`);
}

/** Mobile bottom navigation — Home, Dashboard, Chatbot, Plans, Profile. */
export default function XiBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="xi-bottom-nav" aria-label="Primary mobile">
      <div className="xi-bottom-nav__inner">
        {BOTTOM_NAV.map((item) => {
          const Icon = item.icon;
          const active = isActive(pathname, item.to);
          return (
            <Link
              key={item.key}
              to={item.to}
              className={`xi-bottom-nav__item${active ? ' is-active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              {item.key === 'chatbot' ? <XiBotAvatar size="sm" /> : <Icon aria-hidden="true" />}
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
